<template>
    <div class="mvt-ads" v-if="getId && !removed" :class="{'removable': removable, 'loaded': loaded}" :type="options.type" :index="options.index">
        <div v-once :id="getId"></div>
        <button type="button" v-if="removable" @click="remove" class="circle small default"><i class="icon-times"></i></button>
    </div>
</template>
<script src="./mvt-ads.js"></script>
<style lang="scss">
    @use './mvt-ads.scss' as *;
</style>
